import { EmailContentDefinition } from 'modules/graphql/types';
import { WarningFill } from 'ui/icons';

import { Tooltip } from 'ui/tooltip';

import { useEmailPreviewContext } from '../context/EmailPreviewContext';
import { useEditableFieldsContext } from '../../context/EditableFieldsContext';
import { usePreviewWithDataContext } from '../../context/PreviewWithDataContext';
import { useQueryParamContext } from '../../context/QueryParamContext';
import { ByteSizeWarning, displayContent, TemplateEditViews, getByteSizeInfo } from '../../common';

export const ByteSizeIndicator = () => {
  const { liveTemplate } = useEditableFieldsContext();
  const { messageContent } = useEmailPreviewContext();
  const { isDataFeedDataEmpty, isUserDataEmpty } = usePreviewWithDataContext();
  const { view } = useQueryParamContext();
  const usePopulatedField =
    view === TemplateEditViews.preview && (!isDataFeedDataEmpty || !isUserDataEmpty);
  const emailData = (liveTemplate?.mediumData || {}) as EmailContentDefinition;
  const content = usePopulatedField ? messageContent : emailData.html || '';
  // note: byteSizeInfo is displayed in the UI, so do not define the locale (the locale of the browser will be used)
  const byteSizeInfo = getByteSizeInfo(content);

  if (byteSizeInfo.size > 102)
    return (
      <Tooltip tooltipContent={displayContent.strByteSizeWarning}>
        <ByteSizeWarning>
          <WarningFill isColorInherited />
          {byteSizeInfo.formatted}
        </ByteSizeWarning>
      </Tooltip>
    );
  return (
    <Tooltip tooltipContent={displayContent.strByteSizeInfo}>{byteSizeInfo.formatted}</Tooltip>
  );
};
